/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonRelayerTransferAssetListRequest = {
    clientId?: string;
    period?: BabylonRelayerTransferAssetListRequest.period;
    sortField?: BabylonRelayerTransferAssetListRequest.sortField;
    sortDirection?: BabylonRelayerTransferAssetListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace BabylonRelayerTransferAssetListRequest {

    export enum period {
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
    }

    export enum sortField {
        TOTAL_TRX_COUNT = 'TOTAL_TRX_COUNT',
        RECEIVE_AMOUNT = 'RECEIVE_AMOUNT',
        SEND_AMOUNT = 'SEND_AMOUNT',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

